import React, { Component } from "react";
import moment from "moment";
import "./Payment.scss";
import "../DataCheck/DataCheck.scss";
import Button from "../Button/Button";
import { Redirect } from "react-router-dom";
import Table from "../Table/Table";
import CheckMark from "../CheckMark/CheckMark";
import request from "../../Ajax";
import Loader from "../Loader/Loader";
import sliLogo from "../../assets/img/sil-logo.svg";

const userInfo = [
  { id: "1", label: "Ա/մ նույնականացման համար", value: "285330" },
  { id: "2", label: "ԲՄ տեղեկատվություն", value: "14" },
  { id: "3", label: "Էլ փոստի հասցե", value: "taron.amaryan99@gmail.com" },
  { id: "4", label: "Հեռախոսահամար", value: "+374 93 50 50 50" },
  { id: "5", label: "Սկիզբ", value: "27/05/2019  12։30" },
  { id: "6", label: "Ավարտ", value: "12/08/2019  " },
];

export default class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
      bm: 0,
      price: 0,
      redirect_url: "",
      insuranceList: [],
      policy_number: "",
      error_message: false,
      isFetching: true,
      labels: [],
      userInfo: [],
      icIsActive: false,
    };

    this.inner_state = {
      insuranceCompanyPremium: "insuranceCompanyPremium",
      registerPayment: "registerPayment",
      chooseInsurance: "chooseInsurance",
      labels: "getLabels",
      insuranceCompanyList: "insuranceCompanyList",
      urlMalus: "bonusmalus/" + this.props.data1.policyHolderId,
    };

    this.carInfo = [];
  }

  componentDidUpdate() {
    if (
      Object.keys(this.state.labels).length !== 0 &&
      this.state.isFetching === true
    ) {
      this.setState({ isFetching: false });
    }
  }

  error = (error_message) => {
    return error_message ? (
      <div className="column small-12">
        <div className="date_warning mt_20">
          <span className="custom_icon_warning">!</span>
          <span className="date_warning_text">{error_message}</span>
        </div>
      </div>
    ) : (
      ""
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.policy_number !== "") {
      if (this.state.isChecked) {
        this.setState({ isFetching: true });

        let data_1 = this.props.data1;
        let data_2 = this.props.data2;

        request(
          this.inner_state.registerPayment,
          "post",
          {
            firstName: data_1.firstName,
            lastName: data_1.lastName,
            plateNumber: data_1.plateNumber,
            idNumber: data_1.idNumber,
            email: data_2.email,
            phoneNumber: data_2.phoneNumber,
            startDate: data_2.startDate,
            endDate: data_2.endDate,
            amount: this.state.price,
            token: this.props.data1.token,
            lang: this.props.lang === 2 ? "en" : "hy",
            info: JSON.stringify([data_1, data_2]),
          },
          (response) => {
            if (response.data.status === true) {
              window.location.href = response.data.data;
            } else {
              this.setState({ isFetching: false });
              this.setState({ error_message: response.data.message });
            }
          }
        );
      } else {
        this.setState({ error_message: "!" });
      }
    } else {
      this.setState({
        error_message: "Խնդրում ենք ընտրել ԱՊՊԱ կազմակերպությունը",
      });
    }
  };

  componentDidMount() {
    request(
      this.inner_state.insuranceCompanyPremium,
      "post",
      {
        token: this.props.data1.token,
      },
      (response) => {
        if (response.data.status === true) {
          let prices = JSON.parse(response.data.data);
          let price = 0;

          prices.map((val) => {
            if (val.icId === 4) {
              price = val.premium;
            }
          });

          this.setState({ price: price });
        } else {
          //todo: error message
        }
      }
    );

    request(this.inner_state.urlMalus, "get", {}, (response) => {
      if (response.data.status === true) {
        let userInfo = this.state.userInfo;
        userInfo.push({
          id: "2",
          label: this.state.labels.bm,
          value: response.data.data,
        });
        this.setState({ userInfo: userInfo });
      } else {
        //todo: error message
      }
    });

    request(this.inner_state.insuranceCompanyList, "get", {}, (response) => {
      if (response.data.status === true) {
        let insuranceCompanyList = JSON.parse(response.data.data);
        this.setState({ insuranceCompanyList: insuranceCompanyList });

        this.chooseCompany(4);
      } else {
        //todo: error message
      }
    });

    request(
      this.inner_state.labels,
      "post",
      { page_type: "show_info", lang: this.props.lang },
      (response) => {
        if (response.data.status === true) {
          let labels = response.data.data;
          let userInfo = [];

          if (this.props.data1 !== undefined) {
            userInfo = [
              {
                id: "1",
                label: labels.identification_id,
                value: this.props.data1.policyHolderId,
              },
              { id: "3", label: labels.mail, value: this.props.data2.email },
              {
                id: "4",
                label: labels.phone,
                value: this.props.data2.phoneNumber,
              },
              {
                id: "5",
                label: labels.date_start,
                value: moment(this.props.data2.startDate).format("YYYY-MM-DD"),
              },
              {
                id: "6",
                label: labels.date_end,
                value: moment(this.props.data2.endDate).format("YYYY-MM-DD"),
              },
            ];
            this.setState({ labels: response.data.data, userInfo: userInfo });
          }

          this.carInfo = [
            {
              id: "1",
              label: labels.car_number,
              value: this.props.data1.plateNumber,
            },
            {
              id: "2",
              label: labels.identity_doc,
              value: this.props.data1.idNumber,
            },
            {
              id: "3",
              label: labels.mark,
              value: this.props.data1.vehicleMark,
            },
            {
              id: "4",
              label: labels.model,
              value: this.props.data1.vehicleModel,
            },
            {
              id: "5",
              label: labels.power,
              value: this.props.data1.horsePower,
            },
            {
              id: "6",
              label: labels.purpose,
              value: this.props.data2.useOption.label,
            },
            {
              id: "7",
              label: labels.contract_end,
              value: moment(this.props.data1.suggestedStartDate).format(
                "YYYY-MM-DD"
              ),
            },
          ];
        }
      }
    );
  }

  chooseCompany = (insurance_id) => {
    if (insurance_id === 4) {
      // todo -> remove on future, now for sil insurance
      request(
        this.inner_state.chooseInsurance,
        "post",
        {
          token: this.props.data1.token,
          icId: insurance_id,
        },
        (response) => {
          console.log(response);
          if (response.data.status === true) {
            this.setState({ policy_number: response.data.data });
            this.setState({ icIsActive: true });
          } else {
            //todo: error message
            this.setState({
              error_message: response.data.message,
            });
          }
        }
      );
    }
  };

  listOfCompanies = () => {
    let companies = [];
    for (let i in this.state.insuranceCompanyList) {
      let id = this.state.insuranceCompanyList[i]["id"];
      if (id === 4) {
        this.chooseCompany.bind(null, id);
        companies.push(
          <div className="payment_card" key={i}>
            <div className="payment_card_label">
              {this.state.labels.insurance_company}
            </div>

            <div className="payment_card_img active">
              <img src={sliLogo} alt="" />
            </div>
          </div>
        );
      }
    }

    return companies;
  };

  render() {
    {
      /*<Loader/>*/
    }
    let listOfCompanies = this.listOfCompanies();
    return (
      <>
        {this.state.isFetching ? (
          <Loader />
        ) : this.state.redirect_url !== "" ? (
          <Redirect to={this.state.redirect_url} />
        ) : (
          <>
            <div className="column small-12">
              <div className="top_section">
                <div className="top_section__headline custom-headline">
                  <h2>
                    {/*Վճարում*/}
                    {this.state.labels.payment}
                  </h2>
                </div>
                <div className="top_section__desc">
                  {/*Հարգելի հաճախորդ՝ խնդրում ենք ստուգել ստորև տեղեկատվությունը և անցնել վճարման էջ*/}
                  {this.state.labels.dear_customer}
                </div>
              </div>
            </div>

            <div className="column small-12 large-10">
              <form
                action=""
                className="row align-center"
                onSubmit={this.handleSubmit}
              >
                <div className="column small-12 large-6 fluid-sm">
                  <Table data={this.carInfo} />
                </div>
                <div className="column small-12 large-6 fluid-sm">
                  <Table data={this.state.userInfo} />
                </div>

                <div className="column small-12">
                  <div className="medium-flex-container align-justify payment_info">
                    {listOfCompanies}

                    <div className="payment_card">
                      <div className="payment_card_label">
                        {this.state.labels.amount}
                      </div>

                      <div className="payment_card_text">
                        <span>
                          {this.state.price} {this.state.labels.currency}
                        </span>
                      </div>
                    </div>
                  </div>

                  <CheckMark
                    type="checkbox"
                    id="check-1"
                    name="isChecked"
                    onChange={(event) => {
                      this.setState({ isChecked: event });
                    }}
                    checked={this.state.isChecked}
                    label={this.state.labels.arca_agreement}
                  />
                  <CheckMark
                    type="checkbox"
                    id="check-1"
                    name="isChecked"
                    checked={true}
                    // label={<span>Ծանոթացել եմ «ՀԱՅԷԿՈԿՈՄԲԱՆԿ» ԲԲԸ-ի կողմից ԱՊՊԱ պայմանագրի առցանց կնքման <a href={require("../../assets/pdf/AEB.pdf")} target="_blank">պայմաններին և սակագներին</a> :</span>}
                    label={
                      <span>
                        {this.state.labels.agree}{" "}
                        <a
                          href={require("../../assets/pdf/AEB.pdf")}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {this.state.labels.terms}
                        </a>
                      </span>
                    }
                  />
                  <div className="desc">
                    {this.state.labels.aswa_1}{" "}
                    <a
                      href="https://aswa.am/self-signing/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {this.state.labels.aswa_2}
                    </a>
                  </div>
                </div>

                {this.error(this.state.error_message)}
                <div className="column small-12 large-6">
                  <div className="flex-container align-justify data_check_submit">
                    <Button
                      inner={this.state.labels.previous}
                      onClick={() => {
                        this.props.onPrevious();
                      }}
                      classNames="icon-left"
                      icon="arrow-left"
                      iconPosition="left"
                    />

                    <Button
                      inner={this.state.labels.next}
                      classNames="btn-green icon-right"
                      type="submit"
                      icon="arrow-right"
                      iconPosition="right"
                      disabled={
                        this.state.isChecked && this.state.icIsActive
                          ? false
                          : true
                      }
                    />
                  </div>
                </div>
              </form>
            </div>
          </>
        )}
      </>
    );
  }
}
